export const ConfigPlugin = {
  install(Vue) {
    Vue.prototype.$config = new Config();
  }
};

export default class Config {
  constructor() {
    this.maxEdgeSize = 5;
  }
  nodeRadius(value, maxValue) {
    return 20 * Math.sqrt(value / maxValue) + 10;
  }
  nodeDistance(width) {
    return width / 5;
  }
  nodeCharge(width) {
    return (width - 100) * -1.5;
  }
  nodeLabelPosX(value, maxValue) {
    return 20 * Math.sqrt(value / maxValue) + 14;
  }
}
